<template>
  <section class="about">
    <LandingPage class="landingPage"/>
    <AboutPage />
    <FooterPage class="footerPage"/>
    <Footer />
  </section>
</template>

<script>
import LandingPage from '@/components/hgAbout/LandingPage';
import AboutPage from '@/components/hgAbout/AboutPage';
import FooterPage from '@/components/hgAbout/FooterPage';
import Footer from '@/components/Footer';

export default {
  name: 'About',
  data() {
    return {
      key: false
    }
  },
  components: {
    LandingPage,
    AboutPage,
    FooterPage,
    Footer
  }
}
</script>

<style scoped>
@media (max-width: 900px) {
  .landingPage {
    display: none;
  }
  .footerPage {
    display: none;
  }
}
</style>
